export default function findingCategoryUniqueNameDirective(
  $q,
  amSharedModelService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const auditId = attributes.auditId || -1;
    const findingCategoryId = attributes.findingCategoryId || -1;

    ngModel.$asyncValidators.amFindingCategoryUniqueName = modelValue => amSharedModelService
      .checkFindingCategoryExists(auditId, findingCategoryId, modelValue)
      .then((nameExists) => {
        if (!nameExists) {
          return $q.resolve();
        }
        return $q.reject();
      })
      .catch(() => $q.reject());
  }
}

export const name = 'amFindingCategoryUniqueName';

findingCategoryUniqueNameDirective.$inject = [
  '$q',
  'amSharedModelService'
];
